export default function () {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    { label: "头像", prop: "img_head", slots: "img_head", width: 100 },
    { label: "是否禁用", prop: "disable", slots: "disable", width: 100 },
    { label: "小程序openid", prop: "openid", width: 300 },
    { label: "公众号openid", prop: "gzh_openid", width: 300, slots: "gzh_openid", },
    { label: "用户姓名", prop: "username", width: 120 },
    { label: "手机号", prop: "phone", width: 200, slots: "phone", },
    {
      label: "小程序首次登录时间",
      prop: "create_time",
      width: 200
      // slots: "state",
    },
    // {
    //   label: "公众号登录时间",
    //   prop: "create_time_gzh",
    //   slots: "create_time_gzh",
    // },
    {
      label: "操作",
      prop: "operation",
      width: 120,
      slots: "operation",
      fixed: "right",
    },
  ];
}
